module.exports = __webpack_public_path__ + "static/media/i-e.0fcf6ed.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ware-2018/i-e.mp3
// module id = CPsn
// module chunks = 0